import { BusinessUnitItemSchema } from "@/schemas/business-unit/business-unit-item";
import { z } from "zod";

export const ScanDataBusinessUnitItemSchema = BusinessUnitItemSchema;

export type ScanDataBusinessUnitItemType = z.infer<
  typeof ScanDataBusinessUnitItemSchema
>;
